import { render, staticRenderFns } from "./OfficialMap.vue?vue&type=template&id=aff8cfa0"
import script from "./OfficialMap.vue?vue&type=script&lang=js"
export * from "./OfficialMap.vue?vue&type=script&lang=js"
import style0 from "./OfficialMap.vue?vue&type=style&index=0&id=aff8cfa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports